import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

const TOP_KPIS_FIRST_PAGE = {
  vehiclecount: 0,
  total_km: 0,
  median_range: 0,
  mean_whr_km: 0,
  idel_time_per: 0,
  avg_dis_duration: 0,
  regen_percent: 0,
  median_BCS_max: 0,
  median_BMS_max: 0,
  mcu_temp: 0,
  power_drive_percent: 0,
  dcdc_temp_1: 0,
  dcdc_temp_2: 0,
  eco_drive_percent: 0,
};

function Topkpis_Coral({ gloablfilter }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [vehicleCount, setVehicleCount] = useState(0);
  const [bcsActiveTime, setBcsActiveTime] = useState(null);



  const handleApiResponse = (data) => {
    if (!data || typeof data !== "object") {
      setTopData(TOP_KPIS_FIRST_PAGE);
      return;
    }

    setTopData({
      vehiclecount: data.total_vehicle_count?.value ?? 0,
      total_km: data.distanceInKM?.value
        ? parseFloat(data.distanceInKM.value).toFixed(2)
        : "0.00",

      median_range: data.rangeMedian?.values?.["50.0"]
        ? parseFloat(data.rangeMedian.values["50.0"]).toFixed(2)
        : "0.00",

      mean_whr_km: data.whKMmedian?.values?.["50.0"]
        ? parseFloat(data.whKMmedian.values["50.0"]).toFixed(2)
        : "0.00",

      idel_time_per: data.idleTimePer?.values?.["50.0"]
        ? parseFloat(data.idleTimePer.values["50.0"]).toFixed(2)
        : "0.00",

      avg_dis_duration: data.medianDuration?.values?.["50.0"]
        ? (data.medianDuration.values["50.0"] / 60).toFixed(2)
        : "0.00",

      regen_percent: data.Median_Regen_Per?.values?.["50.0"]
        ? parseFloat(data.Median_Regen_Per.values["50.0"]).toFixed(2)
        : "0.00",

      median_BCS_max: data.BCS_Active_Time_Percent?.values?.["50.0"]
        ? parseFloat(data.BCS_Active_Time_Percent.values["50.0"]).toFixed(2)
        : "0.00",

      median_BMS_max: data.Median_BMS_Max_Temp?.values?.["50.0"]
        ? parseFloat(data.Median_BMS_Max_Temp.values["50.0"]).toFixed(2)
        : "0.00",

      mcu_temp: data.Median_MCU_Temp?.values?.["50.0"]
        ? parseFloat(data.Median_MCU_Temp.values["50.0"]).toFixed(2)
        : "0.00",

      power_drive_percent: data.power_drive_percent?.values?.["50.0"]
        ? parseFloat(data.power_drive_percent.values["50.0"]).toFixed(2)
        : "0.00",

      dcdc_temp_1: data.Median_DCDC_Temp_1?.values?.["50.0"]
        ? parseFloat(data.Median_DCDC_Temp_1.values["50.0"]).toFixed(2)
        : "0.00",

      dcdc_temp_2: data.Median_DCDC_Temp_2?.values?.["50.0"]
        ? parseFloat(data.Median_DCDC_Temp_2.values["50.0"]).toFixed(2)
        : "0.00",

      eco_drive_percent: data.eco_drive_percent?.values?.["50.0"]
        ? parseFloat(data.eco_drive_percent.values["50.0"]).toFixed(2)
        : "0.00",
    });
  };



  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "coral_drive_analysis/vehiclecount",
    }, (response) => {
      // Handle both flat and nested API structures
      const count =
        response?.all_vehicle_count?.value ??
        response?.groupby?.buckets?.[0]?.all_vehicle_count?.value ??
        0;
      setVehicleCount(count);
    });
  }, [gloablfilter]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "coral_drive_analysis/topkpisfirstpage_erc",
        body: { filterdata: gloablfilter },
      },
      handleApiResponse
    );
  }, [gloablfilter]);
  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "coral_drive_analysis/bcs_active_time_percent",
        body: { filterdata: gloablfilter },
      },
      (res) => {
        // Example API response: { "BCS_Active_Time_Percent": { "values": { "50.0": 17.20400047302246 } } }
        if (
          res &&
          res.BCS_Active_Time_Percent &&
          res.BCS_Active_Time_Percent.values &&
          res.BCS_Active_Time_Percent.values["50.0"]
        ) {
          setBcsActiveTime(res.BCS_Active_Time_Percent.values["50.0"]);
        } else {
          setBcsActiveTime(null); // or default/fallback value
        }
      }
    );
  }, [gloablfilter]);

  let loader = (
    <div style={{ margin: "auto" }}>
      <ThreeCircles
        height="50"
        width="40"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor="#3498db"
        innerCircleColor="#dec52d"
        middleCircleColor="#db213a"
      />
    </div>
  );

  const loggedInUser = useSelector(selectLoggedInUser);
  // console.log("KPI Section");
  // console.log("KPI Section");
  console.log(topdata.vehiclecount);

  return (
    <>
      <section className="kpi my-3">
        <div className="row row-cols-2">
          <div className="col ">
            <div
              className={
                (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src={"/assets/img/EV-Logo-1.png"} />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.vehiclecount}|{vehicleCount}</p>
                <p className="m-0">
                  <small className="text-muted drive_span">Avl|Total Vehicles</small>
                </p>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div
              className={
                (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/charging1.png" />{" "}
              </div>
              <div className="ps-2">
                <p className="h5 m-0 kpi_value">{topdata.total_km} km</p>
                <p className="m-0">
                  <small className="text-muted drive_span">
                    Total km travelled
                  </small>
                </p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div
              className={
                (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/electric1.png" />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.median_range} km</p>
                <p className="m-0">
                  <small className="text-muted drive_span">Median Range</small>
                </p>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div
              className={
                (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/charging-station1.png" />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.mean_whr_km} </p>
                <p className="m-0">
                  <small className="text-muted drive_span">Median Wh/Km</small>
                </p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div
              className={
                (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/electric-car1.png" />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.avg_dis_duration} hrs</p>
                <p className="m-0">
                  <small className="text-muted drive_span">
                    Median Discharge Duration
                  </small>
                </p>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div
              className={
                (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/charging-station1.png" />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.idel_time_per}% </p>
                <p className="m-0">
                  <small className="text-muted drive_span">Med. Idle Time percent</small>
                </p>
              </div>
            </div>
          </div>
          {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
            <div className="col evtpks-pl0">
              <div
                className={
                  (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginRight: 0 }}
              >
                <div className="widgetIcon">
                  <img src="/assets/img/battery-charge1.png" />{" "}
                </div>
                <div className="ps-0">
                  <p className="h5 m-0 kpi_value">
                    {topdata.regen_percent} %
                  </p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median Regen Percent
                    </small>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
          <div className="row row-cols-2 mt-2">
            <div className="col ">
              <div
                className={
                  (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src={"/assets/img/Rgen.png"} />{" "}
                </div>
                <div className="pl-0">
                  <p className="h5 m-0 kpi_value">{topdata.eco_drive_percent} %</p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median Eco Drive Percent
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-0">
                  <img src="/assets/img/bcs_active.png" alt="" />{" "}
                </div>
                <div className="ps-1">
                  <p className="h6 m-0 kpi_value">{topdata.power_drive_percent} %</p>
                  <p className="m-0 kpi_text">
                    <small className="text-muted drive_span ">
                      Med. Power Drive Percent
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src="/assets/img/thermometer.png" alt="" />{" "}
                </div>
                <div className="ps-0">
                  <p className="h5 m-0 kpi_value">
                    {parseFloat(bcsActiveTime).toFixed(2)} %
                  </p>
                  <p className="m-0 kpi_text">
                    <small className="text-muted drive_span">
                      Median BCS Active Time Percent
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src="/assets/img/mcu.png" />{" "}
                </div>
                <div className="pl-1">
                  <p className="h5 m-0 kpi_value">
                    {parseFloat(topdata.median_BMS_max).toFixed(1)} &deg;C
                  </p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median BMS Max Cell Temp
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src="/assets/img/motor.png" />{" "}
                </div>
                <div className="pl-1">
                  <p className="h5 m-0 kpi_value">
                    {parseFloat(topdata.mcu_temp).toFixed(1)} &deg;C
                  </p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median MCU Temp
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon">
                  <img src="/assets/img/charging-station1.png" />{" "}
                </div>
                <div className="ps-3">
                  <p className="h5 m-0 kpi_value">{Number(topdata.dcdc_temp_1).toFixed(2)} &deg;C</p>
                  <p className="m-0">
                    <small className="text-muted drive_span">Median DCDC Temp 1</small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src="/assets/img/dcdc.png" />{" "}
                </div>
                <div className="pl-1">
                  <p className="h5 m-0 kpi_value">
                    {parseFloat(topdata.dcdc_temp_2).toFixed(1)} &deg;C
                  </p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median DCDC Temp 2
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
}

export default Topkpis_Coral;
